import { isEmpty } from "lodash";

import { isNil } from "../utils";
import { Values } from "../models/Filter";
import { staffingListFilterBy } from "./Staffing";

/* eslint-disable @typescript-eslint/no-duplicate-enum-values */

export enum PatientFilterByActionDispatchTypes {
  PATIENT_FILTER_BY_FAIL = "PATIENT_FILTER_BY_FAIL",
  PATIENT_FILTER_BY_INVOKE = "PATIENT_FILTER_BY_INVOKE",
  PATIENT_FILTER_BY_SUCCESS = "PATIENT_FILTER_BY_SUCCESS",
}

export const enum FilterOptions {
  ASSIGNED_TO = "ASSIGNEDTO",
  CREATED_BY = "CREATEDBY",
  DISCIPLINES = "Disciplines",
  DISCIPLINE_MULTI = "DISCIPLINE_MULTI",
  GET_PATIENT_COUNTY = "GetPatientCounty",
  GET_PATIENT_STATES = "GetPatientStates",
  HEALTH_PLAN = "HEALTHPLAN",
  HEALTH_PLAN_MULTI = "HEALTH_PLAN_MULTI",
  REFERRAL_STATUS = "ReferralServiceStatus",
  ReferralServiceStatus_Multi = "ReferralServiceStatus_Multi",
  SERVICE_STATUS_REASON = "ServiceStatusReason",
  SERVICE_PROVIDER = "ServiceProvider",
  FILTER_SERVICE_PROVIDER = "Service Provider",
  SERVICE_REQUEST_TYPE = "ServiceType",
  URGENCY = "Urgency",
  STAFFING_STATUS = "StaffingStatus",
  STAGE = "Stage",
  REFERRAL_SOURCE = "ReferralSource",
  REFERRAL_SOURCE_MULTI = "REFERRAL_SOURCE_MULTI",
  FACILITY_TYPE = "FacilityType"
}
export enum urlBuildEnum {
  HEALTHPLAN = "healthPlanName",
  HEALTH_PLAN_MULTI = "HealthPlanIds",
  Urgency = "urgencyStatus",
  Disciplines = "skill",
  DISCIPLINE_MULTI = "skillIds",
  GetPatientCounty = "county",
  GetPatientStates = "state",
  ServiceProvider = "providerNpi",
  ASSIGNEDTO = "assignUser",
  ALL_PENDING_ASSIGNED_TO = "assignedTo",
  ReferralServiceStatus = "serviceStatus",
  ReferralServiceStatus_Multi = "serviceStatusIds",
  ReferralServiceStatusReason = "serviceStatusReason",
  MyPatientStatusReason = "serviceStatusReason",
  CREATEDBY = "userCreated",
  ServiceType = "serviceRequestType",
  StaffingStatus = "staffingStatusIds",
  ServiceStatusReason = "serviceStatusReason",
  Stage = "stage",
  ReferralSource = "facilityTypeName",
  REFERRAL_SOURCE_MULTI = "facilityTypeIds",
  FacilityType = "facilityTypeName",
  ServiceStatus = "serviceStatus",
  ServiceRequestTypeName ="serviceRequestTypeName",
  isBCBSTN ="isBCBSTN",
}

/** new filter enum */
export enum UrlBuildFilterByEnum {
  HEALTH_PLAN = "healthPlanName",
  HEALTH_PLAN_MULTI = "HealthPlanIds",
  HEALTH_PLAN_STAFFING = "healthPlanName",
  URGENCY = "urgencyStatus",
  DISCIPLINE = "skill",
  DISCIPLINE_MULTI = "skillIds",
  GET_PATIENT_STATE = "state",
  SERVICE_PROVIDER = "providerNpi",
  ASSIGNED_TO_USER_ID = "assignUser",
  ALL_PENDING_ASSIGNED_TO = "assignUser",
  REFERRAL_SERVICE_STATUS = "serviceStatus",
  ReferralServiceStatus_Multi = "serviceStatusIds",
  CREATED_BY = "userCreated",
  SERVICE_REQUEST_TYPE = "serviceRequestType",
  STAFFING_STATUS = "staffingStatusIds",
  SERVICE_STATUS_REASON = "serviceStatusReason",
  COUNTY = "county",
  FIRST_NAME = "firstName",
  LAST_NAME = "lastName",
  STAGE = "stage",
  REFERRAL_SOURCE = "facilityTypeName",
  REFERRAL_SOURCE_MULTI = "facilityTypeIds",
  FACILITY_TYPE_BY_TEXT = "facilityTypeName",
}
export const convertedJSON: object = {};

export const enum Labels {
  ASSIGNED_TO = "Assigned To",
  CHOOSE = "Choose",
  CREATED_BY = "CREATEDBY",
  CREATED_BY_SMALL = "Created By",
  SERVICE_PROVIDER = "SERVICE PROVIDER",
  SKILL = "Skill",
  COUNTY = "County",
  STATE = "State",
  HEALTH_PLAN = "Health Plan",
  STAFFING_STATUS = "Staffing Status",
  STATUS = "Status",
  STATUS_REASON = "Status Reason",
  ALL_SERVICE_STATUS_REASON = "Status Reason",
  SERVICE_REQUEST_TYPE = "Service Request Type",
  AUTH_TYPE = "Auth Type",
  URGENCY = "Urgency",
  SERVICE_STATUS_REASON = "Service Status Reason",
  FIRST_NAME = "First Name",
  LAST_NAME = "Last Name",
  STAGE = "Stage",
  REFERRAL_SOURCE = "Referral Source",
  FACILITY_TYPE_BY_TEXT = "Facility Type"
}

export const myPatientListFilterBy: Values[] = [
  {
    value: "HEALTH_PLAN_MULTI",
    label: "Health Plan",
    paramLabel: "HealthPlanIds",
  },
  {
    value: "GetPatientStates",
    label: "State",
    paramLabel: "state",
  },
  {
    value: "Urgency",
    label: "Urgency",
    paramLabel: "urgencyStatus",
  },
  {
    value: "ServiceProvider",
    label: "Service Provider",
    paramLabel: "providerNpi",
  },
  {
    value: "ReferralServiceStatus_Multi",
    label: "Status",
    paramLabel: "serviceStatusIds",
  },
  {
    value: "ServiceStatusReason",
    label: "Service Status Reason",
    paramLabel: "serviceStatusReason",
  },
  {
    value: "DISCIPLINE_MULTI",
    label: "Skill",
    paramLabel: "skillIds",
  },
  {
    value: "FacilityType",
    label: "Referral Source",
    paramLabel: "facilityTypeName",
  },
];
const filterTagMap = new Map();
filterTagMap.set(FilterOptions.GET_PATIENT_COUNTY, "county");
filterTagMap.set(FilterOptions.GET_PATIENT_STATES, "States");
filterTagMap.set(FilterOptions.REFERRAL_STATUS, "Status");
filterTagMap.set(FilterOptions.SERVICE_REQUEST_TYPE, "Service Request Type");
filterTagMap.set(FilterOptions.HEALTH_PLAN, "Health Plan");
filterTagMap.set(FilterOptions.ASSIGNED_TO, Labels.ASSIGNED_TO);
filterTagMap.set(FilterOptions.CREATED_BY, Labels.CREATED_BY_SMALL);
filterTagMap.set(FilterOptions.DISCIPLINES, Labels.SKILL);
filterTagMap.set(FilterOptions.SERVICE_PROVIDER, Labels.SERVICE_PROVIDER);
filterTagMap.set(FilterOptions.STAFFING_STATUS, Labels.STAFFING_STATUS);

export const getFilterTag = (value: string) => {
  const result = filterTagMap.get(value);
  if (!isNil(result)) {
    return filterTagMap.get(value);
  } else return value;
};
export const patientListFilterBy: Values[] = [
  {
    value: "HEALTHPLAN",
    label: "Health Plan",
    paramLabel: "healthPlanName",
  },
  {
    value: "Disciplines",
    label: "Skill",
    paramLabel: "skill",
  },
  {
    value: "GetPatientStates",
    label: "State",
    paramLabel: "state",
  },
  {
    value: "Urgency",
    label: "Urgency",
    paramLabel: "urgencyStatus",
  },
  {
    value: "ASSIGNEDTO",
    label: "Assigned To",
    paramLabel: "assignUser",
  },
  {
    value: "ServiceProvider",
    label: "Service Provider",
    paramLabel: "providerNpi",
  },
  {
    value: "ServiceType",
    label: "Service Request Type",
    paramLabel: "serviceRequestType",
  },
  {
    value: "ReferralServiceStatus",
    label: "Status",
    paramLabel: "serviceStatus",
  },
  {
    value: "ServiceStatusReason",
    label: "Service Status Reason",
    paramLabel: "serviceStatusReason",
  },
];
export const patientListFilterBy_2: Values[] = [
  {
    value: "HEALTH_PLAN_MULTI",
    label: "Health Plan",
    paramLabel: "HealthPlanIds",
  },
  {
    value: "DISCIPLINE_MULTI",
    label: "Skill",
    paramLabel: "skillIds",
  },
  {
    value: "GetPatientStates",
    label: "State",
    paramLabel: "state",
  },
  {
    value: "Urgency",
    label: "Urgency",
    paramLabel: "urgencyStatus",
  },
  {
    value: "ASSIGNEDTO",
    label: "Assigned To",
    paramLabel: "assignUser",
  },
  {
    value: "ServiceProvider",
    label: "Service Provider",
    paramLabel: "providerNpi",
  },
  {
    value: "ServiceType",
    label: "Service Request Type",
    paramLabel: "serviceRequestType",
  },
  {
    value: "ReferralServiceStatus_Multi",
    label: "Status",
    paramLabel: "serviceStatusIds",
  },
  {
    value: "ServiceStatusReason",
    label: "Service Status Reason",
    paramLabel: "serviceStatusReason",
  },
  {
    value: "FacilityType",
    label: "Referral Source",
    paramLabel: "facilityTypeName",
  },
];
export const patientListFilterBy_pdn: Values[] = [
  {
    value: "HEALTH_PLAN_MULTI",
    label: "Health Plan",
    paramLabel: "HealthPlanIds",
  },
  {
    value: "DISCIPLINE_MULTI",
    label: "Skill",
    paramLabel: "skillIds",
  },
  {
    value: "GetPatientStates",
    label: "State",
    paramLabel: "state",
  },
  {
    value: "Urgency",
    label: "Urgency",
    paramLabel: "urgencyStatus",
  },
  {
    value: "ASSIGNEDTO",
    label: "Assigned To",
    paramLabel: "assignUser",
  },
  {
    value: "ServiceProvider",
    label: "Service Provider",
    paramLabel: "providerNpi",
  },
  {
    value: "ServiceType",
    label: "Service Request Type",
    paramLabel: "serviceRequestType",
  },
  {
    value: "FacilityType",
    label: "Status",
    paramLabel: "serviceStatusIds",
  },
  {
    value: "ServiceStatusReason",
    label: "Service Status Reason",
    paramLabel: "serviceStatusReason",
  },
];
export const incompleteRequestFilterBy = [
  {
    value: "Urgency",
    label: "Urgency",
    paramLabel: "urgencyStatus",
  },
  {
    value: "HEALTHPLAN",
    label: "Health Plan",
    paramLabel: "healthPlanName",
  },

  {
    value: "ASSIGNEDTO",
    label: "Assigned To",
    paramLabel: "assignUser",
  },
  {
    value: "GetPatientStates",
    label: "State",
    paramLabel: "state",
  },
  {
    value: "CREATEDBY",
    label: "Created By",
    paramLabel: "userCreated",
  },
  {
    value: "ServiceType",
    label: "Auth Type",
    paramLabel: "serviceRequestType",
  },
  {
    value: "ReferralSource",
    label: "Referral Source",
    paramLabel: "facilityTypeName",
  },
];

export const extractFields = (
  item: any,
  isPatientRecords = false,
  includeOriginalObject = false
) => {
  if (isPatientRecords && !isNil(item.healthPlanName)) {
    return {
      label: item.healthPlanName,
      value: item.healthPlanId,
    };
  }

  const mappings: {
    key: string;
    labelKey?: string;
    valueKey?: string;
    transformValue?: (item: any) => any;
    includeFullObject?: boolean;
  }[] = [
    { key: 'urgencyStatus' },
    { key: 'serviceStatusReason' },
    { key: 'serviceStatus' },
    { key: 'serviceStatusReasonId', labelKey: 'serviceStatusReason', valueKey: 'serviceStatusReason' },
    { key: 'serviceRequestTypeName' },
    { key: 'disciplineName' },
    { key: 'healthPlanName', includeFullObject: true },
    {
      key: 'payerName',
      transformValue: (item) => btoa(`${item.payerId}|||${item.payerName}`),
    },
    { key: 'staffingStatusName' },
    { key: 'benefitPlanNm', includeFullObject: true },
    { key: 'facilityTypeName', valueKey: 'facilityTypeId' },
    { key: 'stageStatus' },
    { key: 'referralNtuReason', valueKey: 'referralNtuReasonId' },
  ];

  for (const map of mappings) {
    if (!isNil(item[map.key])) {
      const label = item[map.labelKey || map.key];
      const value = map.transformValue
        ? map.transformValue(item)
        : item[map.valueKey || map.key];

      const extra = map.includeFullObject && includeOriginalObject ? item : {};
      return {
        label,
        value,
        ...extra,
      };
    }
  }

  return item;
};


export const dropdownFilter = (list: any, isPatientRecords = false) => {
  if (!isEmpty(list)) {
    const firstValue = list[0];
    if (firstValue.value != "") {
      if (
        !isNil(
          firstValue.urgencyId ||
            firstValue.healthPlanId ||
            firstValue.serviceStatus ||
            firstValue.disciplineName ||
            firstValue.serviceRequestTypeName ||
            firstValue.payerId ||
            firstValue.staffingStatusId ||
            firstValue.serviceStatusReasonId ||
            firstValue.stageStatus ||
            firstValue.facilityTypeId
        )
      ) {
        const result = list.map((v: any) => extractFields(v, isPatientRecords));
        return result;
      }
    }
  }
  return [];
};

export const HealthPlanData = {
  label: "",
  value: "",
};

export const UserData = {
  roles: "",
  userPhoto: "",
  email: "",
  firstName: "",
  fullName: "",
  lastLogin: "",
  lastName: "",
  userId: 0,
  userName: "",
  userStatus: "",
  highestCred: null,
  allowedStates: [],
  isPhysician: false,
};

export const HealthPlanInitialData = {
  label: "",
  value: "",
  healthPlanId: 0,
  healthPlanName: "",
  payerId: "",
  payerName: "",
};

export const BenefitPlanInitialData = {
  label: "",
  value: "",
  benefitPlanId: 0,
  benefitPlanName: "",
  healthPlanId: 0,
  product: "",
  benefitPlanUid: "",
  healthPlanUid: "",
  healthPlanState: "",
  benefitPlanNm: "",
};

export const BenefitPlanGroupInitialData = {
  benefitPlanName: "",
  benefitPlanIds: []
};

export const getPrefixChipName = (name: string, activeTab: number) => {
  switch (name) {
    case UrlBuildFilterByEnum.SERVICE_PROVIDER:
      return Labels.SERVICE_PROVIDER;
    case UrlBuildFilterByEnum.ASSIGNED_TO_USER_ID:
    case UrlBuildFilterByEnum.ALL_PENDING_ASSIGNED_TO:
      return Labels.ASSIGNED_TO;
    case UrlBuildFilterByEnum.HEALTH_PLAN:
    case UrlBuildFilterByEnum.HEALTH_PLAN_STAFFING:
    case UrlBuildFilterByEnum.HEALTH_PLAN_MULTI:
      return Labels.HEALTH_PLAN;
    case UrlBuildFilterByEnum.URGENCY:
      return Labels.URGENCY;
    case UrlBuildFilterByEnum.CREATED_BY:
      return Labels.CREATED_BY_SMALL;
    case UrlBuildFilterByEnum.SERVICE_REQUEST_TYPE:
      return activeTab === 2 ? Labels.AUTH_TYPE : Labels.SERVICE_REQUEST_TYPE;
    case UrlBuildFilterByEnum.DISCIPLINE:
    case UrlBuildFilterByEnum.DISCIPLINE_MULTI:
      return Labels.SKILL;
    case UrlBuildFilterByEnum.GET_PATIENT_STATE:
      return Labels.STATE;
    case UrlBuildFilterByEnum.REFERRAL_SERVICE_STATUS:
    case UrlBuildFilterByEnum.ReferralServiceStatus_Multi:
      return Labels.STATUS;
    case UrlBuildFilterByEnum.SERVICE_STATUS_REASON:
      return Labels.SERVICE_STATUS_REASON;
    case UrlBuildFilterByEnum.COUNTY:
      return Labels.COUNTY;
    case UrlBuildFilterByEnum.STAFFING_STATUS:
      return Labels.STAFFING_STATUS;
    case UrlBuildFilterByEnum.FIRST_NAME:
      return Labels.FIRST_NAME;
    case UrlBuildFilterByEnum.LAST_NAME:
      return Labels.LAST_NAME;
    case UrlBuildFilterByEnum.STAGE:
      return Labels.STAGE;
    case UrlBuildFilterByEnum.REFERRAL_SOURCE:
    case UrlBuildFilterByEnum.REFERRAL_SOURCE_MULTI:
      return Labels.REFERRAL_SOURCE;
    default:
      return "";
  }
};

export const getFilterDropDownList = (activeTab: number) => {
  switch (activeTab) {
    case 0:
      return myPatientListFilterBy;
    case 1:
      return patientListFilterBy_2;
    case 2:
      return incompleteRequestFilterBy;
    case 3:
      return staffingListFilterBy;
    case 4:
      return patientListFilterBy_pdn;
    default:
      break;
  }
};
